/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pc_Tut_Forms_3Inputs */

const en_pc_tut_forms_3 = /** @type {(inputs: Pc_Tut_Forms_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Toggle layers and open attachments from the panels on the right.`)
};

const zh_pc_tut_forms_3 = /** @type {(inputs: Pc_Tut_Forms_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`在右侧面板中切换图层、打开附件。`)
};

/**
* | output |
* | --- |
* | "Toggle layers and open attachments from the panels on the right." |
*
* @param {Pc_Tut_Forms_3Inputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const pc_tut_forms_3 = /** @type {((inputs?: Pc_Tut_Forms_3Inputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pc_Tut_Forms_3Inputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pc_tut_forms_3(inputs)
	return zh_pc_tut_forms_3(inputs)
});
export { pc_tut_forms_3 as "pc.tut.forms.3" }